import { Pipe, PipeTransform } from '@angular/core';
import { QuestionnaireRequest } from 'src/API';
import { QuestionnaireRequestService } from 'src/app/core/api/questionnaire-request.service';

@Pipe({
  name: 'questionnaireStatus'
})
export class QuestionnaireStatusPipe implements PipeTransform {
  constructor(private questionnaireRequestService: QuestionnaireRequestService) {}

  transform(questionnaire: QuestionnaireRequest): 'Completed' | 'Expired' | 'Incomplete' {
    if (questionnaire.completedAt) {
      return 'Completed';
    }

    if (this.questionnaireRequestService.isQuestionnaireExpired(questionnaire)) {
      return 'Expired';
    }

    return 'Incomplete';
  }
}
